import Vue from "vue";

const getters = {
  auction: (state) => state.auction,
  activeAuctions: (state) => state.auction?.rows,
  auctionCount: (state) => state.auction?.rows.length,
  hasAuctions: (state) => state.auction?.rows.length > 0,
  currentGroup: (state) => state.auction?.currentGroup || 1,

  getAuctionRowById: (state) => (id) => {
    if (!state.auction?.rows.length) {
      return null
    }
    return state.auction.rows.find(a => a.id === id)
  }
}
const actions = {
  setAuctions({ commit, getters }, auction) {
    commit('setAuction', auction)
  },
  setSocketStatus({ commit, getters }, status) {
    commit('setSocketStatus', status)
  },
  updateAuctionRow({ commit, getters }, auctionRow) {
    commit('updateAuctionRow', auctionRow)
  },
}

const state = {
  auctions: [],
  socketConnected: false,
  loading: false,
  error: null
}

const mutations = {
  setAuction(state, auction) {
    Vue.set(state, 'auction', auction);
  },
  setSocketStatus(state, status) {
    Vue.set(state, 'socketConnected', status);
  },
  updateAuctionRow(state, auction) {
    const idx = state.auction.rows.findIndex(a => a.id === auction.id);

    if (idx !== -1) {
      const data = {...state.auction.rows[idx], ...auction}
      Vue.set(state.auction.rows, idx, data);
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
